import { render } from "./ColorBar.vue?vue&type=template&id=4b188667&scoped=true&ts=true"
import script from "./ColorBar.vue?vue&type=script&lang=ts"
export * from "./ColorBar.vue?vue&type=script&lang=ts"

import "./ColorBar.vue?vue&type=style&index=0&id=4b188667&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b188667"]])

export default __exports__